import * as React from 'react';
import { isSameDay } from 'date-fns';
import { compose } from 'recompose';
import { createStyles, List, ListItem, ListItemText } from '@material-ui/core';
import { toCssValue } from '@topconagriculture/theme';
import { withBaseProps } from '../../../../Utils';
const styles = (theme) => createStyles({
    root: {
        margin: toCssValue([0, 15]),
    },
    listItem: {
        padding: theme.space.padding.small,
        paddingRight: theme.space.padding.largest,
        marginBottom: theme.space.margin.small,
        borderRadius: theme.common.borderRadius.default,
        boxShadow: theme.common.shadow.default,
        minHeight: 50,
    },
});
const isSameRange = (first, second) => {
    const { startDate: fStart, endDate: fEnd } = first;
    const { startDate: sStart, endDate: sEnd } = second;
    if (fStart && sStart && fEnd && sEnd) {
        return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
    }
    return false;
};
const DateRangePickerComponentDefinedRanges = (props) => {
    const { classes, t, ranges, theme, selectedRange, setRange } = props;
    return (React.createElement(List, { className: classes.root }, ranges.map((range, idx) => (React.createElement("div", { key: idx, style: { backgroundColor: isSameRange(range, selectedRange) ? theme.color.primary.main : '' } },
        React.createElement(ListItem, { className: classes.listItem, button: true, key: idx, onClick: () => setRange(range) },
            React.createElement(ListItemText, { primaryTypographyProps: {
                    variant: 'body2',
                    style: {
                        fontWeight: isSameRange(range, selectedRange) ? 'bold' : 'normal',
                        color: isSameRange(range, selectedRange) ? theme.color.font.light : theme.color.font.dark,
                    },
                } }, t(`dates:${range.labelKey}`))))))));
};
export default compose(withBaseProps({ styles }))(DateRangePickerComponentDefinedRanges);
//# sourceMappingURL=DateRangePickerComponentDefinedRanges.js.map